import { ADMIN_PIN } from "@/constants/admin";
import { writeAuthHeadersForMultipart } from "@/lib/cloud-admin-sync";

export async function uploadProductImage(file: File): Promise<{ url: string }> {
  const fd = new FormData();
  fd.append("file", file);
  if (ADMIN_PIN) fd.append("pin", ADMIN_PIN);

  const r = await fetch("/api/upload-product-image", {
    method: "POST",
    headers: writeAuthHeadersForMultipart(),
    body: fd,
  });

  const data = (await r.json().catch(() => ({}))) as { error?: string; url?: string };
  if (!r.ok) {
    throw new Error(data.error ?? `Upload failed (${r.status})`);
  }
  if (!data.url) {
    throw new Error("Upload response missing url");
  }
  return { url: data.url };
}
